import GitHub from "../../assets/icons/about/LinkButton/GitHub.svg";
import GitHubHover from "../../assets/icons/about/LinkButton/GitHubHover.svg";

import Linkedin from "../../assets/icons/about/LinkButton/Linkedin.svg";
import LinkedinHover from "../../assets/icons/about/LinkButton/LinkedinHover.svg";


import cv from "../../assets/icons/about/LinkButton/cv.svg";
import cvHover from "../../assets/icons/about/LinkButton/cvHover.svg";

export const imgIcon = {
  gitGub: {
    static: GitHub,
    hover: GitHubHover
  },
  linkedin: {
    static: Linkedin,
    hover: LinkedinHover
  },
  CV:{
    static: cv,
    hover: cvHover
  }
}